import * as React from 'react';
import { createSvg } from './utils/createSvg';
export var RatingFilled = createSvg(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M31.64 12.27l-8.45 7 4.25 11.34a1 1 0 01-1.52 1.17L16 24.73l-9.92 7.08a1 1 0 01-1.52-1.17l4.25-11.33-8.45-7A1 1 0 011 10.5h9.84L15.1.6A1 1 0 0116 0a1 1 0 01.92.61l4.22 9.89H31a1 1 0 01.64 1.77z" })), '0 0 32 32', 'RatingFilled');
//# sourceMappingURL=RatingFilled.js.map